//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const Devtools = lazy(() => import('./Devtools.tsx'));
export const DevtoolsApp = lazy(() => import('./App.tsx'));
